import React, { useState } from 'react';
import api from '../utils/api';

const MANUAL_OPEN_TOKEN_URL =
    process.env.REACT_APP_INSTRUCTIONS_MANUAL_OPEN_TOKEN_URL || '/instructions-manual/open-token';

function resolveManualRequestUrl() {
    if (/^https?:\/\//i.test(MANUAL_OPEN_TOKEN_URL) || MANUAL_OPEN_TOKEN_URL.startsWith('//')) {
        return MANUAL_OPEN_TOKEN_URL;
    }
    if (MANUAL_OPEN_TOKEN_URL.startsWith('/api/')) {
        return MANUAL_OPEN_TOKEN_URL.slice(4);
    }
    return MANUAL_OPEN_TOKEN_URL;
}

function resolveManualOpenUrl(url) {
    if (!url) return '';
    if (/^https?:\/\//i.test(url) || url.startsWith('//')) {
        return url;
    }
    if (url.startsWith('/api/')) {
        const apiBase = api.defaults.baseURL || '/api';
        if (/^https?:\/\//i.test(apiBase)) {
            const parsedBase = new URL(apiBase);
            return `${parsedBase.origin}${url}`;
        }
    }
    return url;
}

export default function InstructionsManual() {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const handleOpenManual = async () => {
        setError('');
        setIsLoading(true);

        const popup = window.open('about:blank', '_blank');
        if (popup) {
            popup.opener = null;
        }

        try {
            const { data } = await api.get(resolveManualRequestUrl());
            const manualUrl = resolveManualOpenUrl(data?.url);
            if (!manualUrl) {
                throw new Error('Missing instructions manual URL.');
            }
            if (popup) {
                popup.location.replace(manualUrl);
            } else {
                window.open(manualUrl, '_blank', 'noopener,noreferrer');
            }
        } catch (err) {
            if (popup) {
                popup.close();
            }
            setError(
                err.response?.data?.message ||
                'לא ניתן לפתוח את מדריך המשתמש.',
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="page page--accent stack stack--lg">
            <header className="page__header">
                <h1 className="page__title">
                    {'מדריך משתמש'}
                </h1>
            </header>

            {error && <div className="alert alert--danger">{error}</div>}

            <button
                type="button"
                className="card manual-viewer manual-viewer--link"
                onClick={handleOpenManual}
                disabled={isLoading}
            >
                <span className="manual-viewer__title">
                    {isLoading
                        ? 'פותח...'
                        : 'פתח מדריך משתמש'}
                </span>
                <span className="card__meta">
                    {'המדריך ייפתח בלשונית חדשה.'}
                </span>
            </button>
        </div>
    );
}
